import { Outlet } from 'react-router';

import InitGuard from 'routes/guards/InitGuard';

export default function InitLayout() {
  return (
    <InitGuard>
      <Outlet />
    </InitGuard>
  );
}
